import { Box, Flex, Heading, Text, Button, Icon } from "@chakra-ui/react";
import { Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme/colors";

export default function PendingAssignment() {
  const { profile, user, signOut } = useAuth();
  return (
    <Flex direction="column" align="center" justify="center" minH="70vh" textAlign="center" data-testid="pending-assignment">
      <Flex align="center" justify="center" w="64px" h="64px" borderRadius="16px" bg={colors.pendingBg} mb="5">
        <Icon as={Clock} boxSize="7" color={colors.pendingText} />
      </Flex>
      <Heading fontFamily="heading" fontWeight="700" fontSize="2xl" color={colors.textPrimary} mb="2">
        Your account is pending assignment
      </Heading>
      <Text color={colors.textSecondary} maxW="460px" mb="1">
        Hi {profile?.full_name || user?.email}, your account is verified but not yet linked to a company.
      </Text>
      <Text color={colors.textSecondary} maxW="460px" mb="6">
        An administrator needs to assign you a company and role before you can access data. You'll get access as soon as that's done.
      </Text>
      <Button variant="outline" onClick={signOut} data-testid="pending-signout">
        Sign out
      </Button>
    </Flex>
  );
}
